import ApiService from "./api.service";

const MessageService = {
  async loadMessages() {
    try {
      return await ApiService.get("threadsUsers");
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async loadMessageDetail(id) {
    try {
      return await ApiService.get(`threadsUsers/${id}`);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async deleteMessages(ids) {
    try {
      return await ApiService.delete("threadsUsers", { ids });
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export { MessageService };
